import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {  ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { CardServiceService } from '../Services/card-service.service';
import { AccountService } from '../Services/account.service';

@Component({
  selector: 'app-card-nick-name',
  templateUrl: './card-nick-name.component.html',
  standalone:false,
  styleUrls: ['./card-nick-name.component.scss']
})


export class CardNickNameComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  internalId:string="";
  CardName:string=""
  oldCardNick: any;
  constructor(private route:ActivatedRoute, private location: Location,private auth:AuthService,private commonP:CommonService,private _router:Router,private cardService:CardServiceService,private account:AccountService) { }

   ngOnInit(){

    this.route.queryParams.subscribe(params => {
      if(params['id']){

        this.internalId=params['id'];
      }if(params['nickName']){
       this.oldCardNick =params['nickName'];
        this.CardName=params['nickName'];
      }

    });


  }

  showModal(num) {
    this.modalObservable.next(num);
  }
updateNickName(name){
let body={
  InternalId:this.internalId,
  NickName: name ? '' : this.CardName
}

  this.commonP.presentLoading();
  this.cardService.UpdateNickName(body,this.auth.accessToken).then((data:any)=>{
    if(data?.response?.code==1){

      this.account.GetLoanDashboard(this.auth.accessToken).then((data:any)=>{
        if(data?.response?.code==1){

          this.commonP.hideLoading();

          if(name=='remove'){
          
            this.commonP.showSuccessToast('You have succesfully removed the nickname of your selected card','Card Nickname Removed');
    
    
    
        }else if(this.CardName){
          this.commonP.showSuccessToast('You have succesfully added the nickname of your selected card','Card Nickname Added');
    
          }
          this._router.navigateByUrl('/DashboardCreditCards');
         
        }else{
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert('', '', this._router, data);
        }
      })

          
    }else{
      
      this.commonP.hideLoading();
      this.commonP.ParseErrorAlert('', '', this._router, data);
    }



  })

}
isValid(){
  if(this.CardName != null && this.CardName != "" && this.oldCardNick !=  this.CardName){
    return false
  }else{
    return true
  }
}


  back() {
    this.location.back()
  }


}
